import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-location-vacations',
    templateUrl: './location-vacations.component.html',
    styleUrls: ['./location-vacations.component.css'],
    standalone: false
})
export class LocationVacationsComponent implements OnInit {
  @Input() locationId!: string;

  constructor() { }

  ngOnInit(): void {
  }
}
